import React, { useMemo, useState } from "react";
import "./gallery.css";

export const Gallery = ({ data = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = data || [];
  const hasImages = images.length > 0;

  const frames = useMemo(() => {
    if (!hasImages) return [];
    const len = images.length;
    if (len === 1) return [{ slot: "center", idx: 0 }];
    if (len === 2)
      return [
        { slot: "left", idx: currentIndex },
        { slot: "right", idx: (currentIndex + 1) % len },
      ];
    const offsets = [-1, 0, 1];
    return offsets.map((offset) => ({
      slot: offset === 0 ? "center" : offset === -1 ? "left" : "right",
      idx: (currentIndex + offset + len) % len,
    }));
  }, [currentIndex, hasImages, images]);

  const handlePrev = () => {
    if (!hasImages) return;
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = () => {
    if (!hasImages) return;
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  if (!hasImages) {
    return (
      <section id="portfolio" className="gallery-section">
        <div className="gallery">
          <div className="gallery__header">
            <h2>Galería</h2>
            <p>Vivencias</p>
          </div>
          <p>Cargando...</p>
        </div>
      </section>
    );
  }

  return (
    <section id="portfolio" className="gallery-section">
      <div className="gallery">
        <div className="gallery__header">
          <h2>Galería</h2>
          <p>Vivencias</p>
        </div>

        <div className="gallery__carousel">
          <button
            type="button"
            className="gallery__nav-btn gallery__nav-btn--prev"
            onClick={handlePrev}
            aria-label="Imagen anterior"
          >
            {"<"}
          </button>

          <div className="gallery__track">
            {frames.map(({ slot, idx }) => {
              const img = images[idx];
              const src = img.largeImage || img.smallImage;
              const safeUrl = src ? encodeURI(src) : "";
              return (
                <div
                  key={`${slot}-${idx}`}
                  className={`gallery-card gallery-card--${slot}`}
                  style={{ backgroundImage: `url("${safeUrl}")` }}
                  role="img"
                  aria-label={img.title || "Foto de la galería"}
                >
                  {(img.title || img.description) ? (
                    <div className="gallery-card__label">
                      {img.title || img.description}
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>

          <button
            type="button"
            className="gallery__nav-btn gallery__nav-btn--next"
            onClick={handleNext}
            aria-label="Imagen siguiente"
          >
            {">"}
          </button>
        </div>

        <div className="gallery__dots" role="tablist" aria-label="Selector de imagen">
          {images.map((_, i) => (
            <button
              key={i}
              type="button"
              className={`gallery__dot ${i === currentIndex ? "is-active" : ""}`}
              aria-label={`Ir a la imagen ${i + 1}`}
              aria-selected={i === currentIndex}
              onClick={() => setCurrentIndex(i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
